import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DndModule } from 'ngx-drag-drop';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { OrderModule } from 'ngx-order-pipe';
import { PlaybookEditorModule } from 'src/app/playbook-editor/playbook-editor.module';
import { NavHolderModule } from 'src/app/playbook-editor/shared/modules/nav-holder.module';
import { PageTemplateEditorComponent } from '../../components/page-template-editor/page-template-editor.component';
import { TemplateEditorComponent } from '../../components/template-editor/template-editor.component';
import { FullscreenDirectiveModule } from '../fullscreen/fullscreen';
import { SwipeShowDirectiveModule } from '../swipe-show/swipe-show';

@NgModule({
    exports: [],
    declarations: [
        TemplateEditorComponent,
        PageTemplateEditorComponent
    ],
    imports: [
        CommonModule,
        DragDropModule,
        PlaybookEditorModule,
        DndModule,
        OrderModule,
        FilterPipeModule,
        NavHolderModule,
        SwipeShowDirectiveModule,
        FullscreenDirectiveModule
    ]
})
export class PageTemplateEditorModule { }
